import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from './components/ui/toaster';
import { AuthProvider, useAuth } from './context/AuthContext';
import { AppProvider } from './context/AppContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Diary from './pages/Diary';
import AddFood from './pages/AddFood';
import AddExercise from './pages/AddExercise';
import Progress from './pages/Progress';
import More from './pages/More';
import Profile from './pages/Profile';
import Onboarding from './pages/Onboarding';

function AppRouter() {
  const { user } = useAuth();

  return (
    <Routes>
      <Route
        path="/onboarding"
        element={user ? <Navigate to="/dashboard" replace /> : <Onboarding />}
      />
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <AppProvider>
              <AuthedRoutes />
            </AppProvider>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

function AuthedRoutes() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="diary" element={<Diary />} />
        <Route path="progress" element={<Progress />} />
        <Route path="more" element={<More />} />
        <Route path="profile" element={<Profile />} />
      </Route>
      <Route path="add-food/:meal" element={<AddFood />} />
      <Route path="add-exercise" element={<AddExercise />} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
